// uuid v14 is pure ESM with no default export, which breaks babel's
// _interopRequireDefault when code uses `import uuid from 'uuid'`.
//
// This shim makes BOTH import styles work correctly:
//   import uuid from 'uuid'           → uuid is the v4 function
//   import { v4 as uuid } from 'uuid' → v4 is the v4 function
//
// Loaded via NormalModuleReplacementPlugin (not resolve.alias) so that
// this file's own import from 'uuid' is NOT replaced, avoiding circular resolution.
import { v4 } from 'uuid';

export default v4;
export { v4 };
